/* istanbul ignore file */
import { useSearchParameter } from 'framework/routing';
import useLeavesErrorMap from './createupdate/errorHandlers';
import CategorizedBusinessRulesListField from './shared/field/CategorizedBusinessRulesListField';

const BalancesListPage = () => {
  const violatedRulesParam = useSearchParameter('rules');
  const violatedRules = violatedRulesParam ? JSON.parse(violatedRulesParam) : [];
  return <CategorizedBusinessRulesListField value={violatedRules} errorMap={useLeavesErrorMap()} />;
};

export default BalancesListPage;
